import NavigationMenu_ProjectsLocalSettings from "../local-settings";
import {PopoverMenuItemType} from "../../../core/gd-components/popover-menu/popover-menu/const";
import {ProjectsTreeSortType} from "../../../core/model2/space/@types";
import FormToggle from "../../../core/gd-form/form-element/toggle-new/toggle";
import React from "react";
import {EVENT_BUS_MENU_RERENDER} from "../sections/const";
import menu_collapseAllProjects from "./collapse-all";
import menu_expandAllProjects from "./expand-all";
import {SpaceProto} from "../../../core/model2/space/space-proto";

export default function spacePreferences_PopoverMenuOptions(space: SpaceProto, localSettings?: NavigationMenu_ProjectsLocalSettings, onReset?: callback) {

    const setManual = () => {
        space.projectsSorting = ProjectsTreeSortType.MANUAL_OLD

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const setAlphabetical = () => {
        space.projectsSorting = ProjectsTreeSortType.ALPHABETICAL

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onSortDefaultReset = () => {
        space.resetSortedMap()
        onReset?.()
    }

    const onColorizeChange = (value:boolean) => {

        // gd.user.settings.menu.projectsColorize = value
        // gd.user.settings.menu.save()
        space.projectsColorize = value

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onCollapseAll = ()=> {
        menu_collapseAllProjects(space, localSettings)
    }

    const onExpandAll = ()=> {
        menu_expandAllProjects(space, localSettings)
    }

    let options: Option[] = [
        {
            icon        : 'i5-collapse',
            value       : true,
            label       : 'Collapse all',
            helpMessage : '',
            onClick     : onCollapseAll
        },
        {
            icon        : 'i5-expand',
            value       : false,
            label       : 'Expand all',
            helpMessage : '',
            onClick     : onExpandAll
        },
        {
            type        : PopoverMenuItemType.SEPARATOR
        },
        {
            icon        : 'i5-az-sort',
            value       : ProjectsTreeSortType.ALPHABETICAL,
            label       : "A - Z",
            helpMessage : 'Order projects alphabetically',
            isSelected  : space.projectsSorting === ProjectsTreeSortType.ALPHABETICAL,
            onClick     : setAlphabetical
        },
        {
            icon        : 'i5-manual-sort',
            value       : ProjectsTreeSortType.MANUAL_OLD,
            label       : 'Manual',
            helpMessage : 'Drag and drop to reorder projects manually',
            isSelected  : space.projectsSorting === ProjectsTreeSortType.MANUAL_OLD,
            onClick     : setManual
        },
        {
            icon        : 'i5-reset',
            label       : "Reset manual sorting",
            onClick     : onSortDefaultReset,
            disabled    : space.projectsSorting === ProjectsTreeSortType.ALPHABETICAL || !space.isResetManualSortingAvailable,
            helpMessage : 'Reset sorting to default'
        },
        {
            type: PopoverMenuItemType.SEPARATOR
        },
        {
            type        : PopoverMenuItemType.COMPONENT,
            component   : () => {
                return (
                    <div className="option fl-jsb">
                        <div className="label">Icon Color</div>
                        <FormToggle size="16" value={space.projectsColorize} onChange={onColorizeChange}/>
                    </div>
                )
            },
            helpMessage : 'Colorize project/folder icons'
        },
    ]

    return options

}
